import React, { useState, useRef, useEffect } from "react";
import "../../styles/BuildingPreviews/CommunityChatbot.css";

const CommunityChatbot = ({ isOpen, onClose }) => {
  const [messages, setMessages] = useState([
    { text: "Hi! Ask me anything about this area.", sender: "bot" }
  ]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);

  const handleSend = () => {
    if (!input.trim()) return;

    const userMessage = { text: input, sender: "user" };
    setMessages([...messages, userMessage]);
    setInput("");

    setTimeout(() => {
      setMessages(prev => [
        ...prev,
        { text: "That's a great question! AI responses coming soon.", sender: "bot" }
      ]);
    }, 1000);
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  if (!isOpen) return null;

  return (
    <div className="chatbotContainer">
      <div className="chatbotHeader">
        <span>💬 Community Guide</span>
        <button className="chatbotCloseBtn" onClick={onClose}>×</button>
      </div>

      <div className="chatbotMessages">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={msg.sender === "bot" ? "chatbotMessage" : "userMessage"}
          >
            {msg.text}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <div className="chatbotInputContainer">
        <input
          className="chatbotInput"
          type="text"
          placeholder="Ask about this area..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleSend()}
        />
        <button className="chatbotSendBtn" onClick={handleSend}>➤</button>
      </div>
    </div>
  );
};

export default CommunityChatbot;
